import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { StorageService } from '../../../../core/storage/storageService';
import { TransactionFacade } from '../../../../models/transactions/transactionFacade';
import { TransactionService } from '../../../../models/transactions/transactionService';
import { TableView } from '../../../../components/ui/filterable-table/tableView';
import { FilterableTableComponent } from '../../../../components/ui/filterable-table/filterable-table.component';
import { TransactionTableViewComponent } from '../../../../components/transaction/transaction-table-view/transaction-table-view.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-transactions',
  templateUrl: './customer-transactions.component.html',
  standalone: false,
})
export class CustomerTransactionsComponent implements OnChanges {
  @Input() customerId: string | undefined = undefined;
  @ViewChild('transactionTable', { static: false }) transactionTable:
    | FilterableTableComponent
    | undefined;
  pageSize: number = 10;

  public transactions: TransactionFacade[] = [];
  public options: any = {
    pageSize: 10,
  };

  transactionsTableView: any;
  selectedTransaction: Partial<TransactionFacade> | undefined;

  constructor(
    public storage: StorageService,
    public transactionService: TransactionService,
    private router: Router,
  ) {
    this.options.customerId = this.customerId;
    this.transactionsTableView = new TableView(TransactionTableViewComponent);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customerId'].currentValue != undefined) {
      this.options.customerId = this.customerId;
      this.transactionTable?.setOptions(this.options);
      this.transactionTable?.reload();
    }
  }

  getOptions(): any {
    return {
      pageSize: this.pageSize,
      customerId: this.customerId,
    };
  }

  handleTableInitialized() {
    this.transactionTable?.setOptions(this.getOptions());
  }

  handleRecordSelected(transaction: TransactionFacade) {
    this.selectedTransaction = transaction;
  }

  btnCloseDetails_clicked() {
    this.selectedTransaction = undefined;
  }
}
